module.exports = window.dnn.Sites.CommonActions;